import gsap from 'gsap';
const InitAlpine = {
  makeRequest() {
    return {
      request_name: '',
      request_email: '',
      request_tel: '',
      request_message: '',
      request_privacy: false,
      submitText: 'Zap It! 🫰',
      isLoading: false,
      reset: {
        request_name: '',
        request_email: '',
        request_tel: '',
        request_message: '',
        request_privacy: false,
        submitText: 'Zap It! 🫰',
        isLoading: false,
      },
      resetForm() {
        Object.assign(this, this.reset);
      },
      async handleSubmit() {
        if (this.isLoading) return;
        this.isLoading = true;
        this.submitText = 'Zap! 👍';

        try {
          const response = await fetch('/wp-json/dcraft/v1/request', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              nonce: frontendAjaxObject.nonce,
              request_name: this.request_name,
              request_email: this.request_email,
              request_tel: this.request_tel,
              request_message: this.request_message,
              request_privacy: this.request_privacy,
            }),
          });

          if (!response.ok) {
            throw new Error('Network response was not ok');
          }

          const data = await response.json();
          if (data.success) {
            this.submitText = 'Nice! 👌';
            this.$store.ui.openModal({
              title: '감사합니다.',
              content:
                '문의 주신 내용이 전상적으로 전달되었습니다.<br />빠른 시일 내에 답변 드리겠습니다.',
              size: 'lg',
            });
            setTimeout(() => {
              this.resetForm();
            }, 1000);
          }
        } catch (error) {
          console.error('Error:', error);
        } finally {
          this.isLoading = false;
        }

        // Simulate a form submission

        this.isLoading = false;
      },
    };
  },
  globalAlpine() {
    return {
      formOpen: false,
      leaving: false,
      init() {
        this.$watch('formOpen', (isOpen) => {
          const divSwiper = this.$root.querySelector('.swiper--container');
          const glassyWrap = this.$root.querySelector('.glassy--wrap');
          if (!divSwiper || !glassyWrap) return;

          if (isOpen) {
            // 열기: 초기 상태 세팅 후 등장
            gsap.set([divSwiper, glassyWrap], { opacity: 0 });
            gsap.set(glassyWrap, { y: 20 });

            this.$nextTick(() => {
              gsap
                .timeline()
                .to(glassyWrap, {
                  opacity: 1,
                  y: 0,
                  duration: 0.5,
                  ease: 'power3.out',
                })
                .to(divSwiper, { opacity: 1, duration: 0.5 }, '<0.1');
            });
          } else {
            // 닫기: 먼저 leaving=true 로 DOM 유지
            this.leaving = true;

            gsap
              .timeline({
                onComplete: () => {
                  // 애니 끝난 후 숨김 허용
                  this.leaving = false;
                },
              })
              .to(glassyWrap, {
                opacity: 0,
                y: 20,
                duration: 0.5,
                ease: 'power3.in',
              })
              .to(divSwiper, { opacity: 0, duration: 0.5 }, '<0.1');
          }
        });
      },
    };
  },
};

export default InitAlpine;
